export const KatalonLogo = () => (
  <img
    alt="Katalon Logo"
    src="https://2465122.fs1.hubspotusercontent-na1.net/hub/2465122/hubfs/g_fNa7d1_400x400%20(1).jpg?width=32&height=32"
    style={{
      borderRadius: '50%',
    }}
  />
);
